export type AuditEventCategory = "AFFILIATION" | "EMPLOYMENT" | "CONTACT" | "PERSONAL" | "MEMBERSHIP";

export const SECTION_AUDIT_CATEGORIES: AuditEventCategory[] = ["AFFILIATION", "EMPLOYMENT", "CONTACT", "PERSONAL"];

export const DEFAULT_AUDIT_CATEGORIES: AuditEventCategory[] = ["AFFILIATION", "EMPLOYMENT"];

export const AUDIT_CATEGORY_LABELS: Record<AuditEventCategory, string> = {
  AFFILIATION: "Affiliation",
  EMPLOYMENT: "Employment",
  CONTACT: "Contact",
  PERSONAL: "Personal",
  MEMBERSHIP: "Membership"
};
